// ✅ Shared PDF page sizes

// 16:9 Landscape (small but consistent)
export const PDF_PAGE_16_9 = {
  width: 960,
  height: 540,
};

// Export default so all slides use this size
export const PDF_PAGE = PDF_PAGE_16_9;
